export function areEqualOrBothEmpty(a: any, b: any): boolean {
  return a === b || (!a && !b);
}
